import {
    Box,
    Button,
    Stack,
    Step,
    StepButton,
    StepLabel,
    Stepper,
    Typography,
} from '@mui/material';
import {
    CustomStepConnector,
    CustomStepIcon,
} from 'pages/admin/campaign-data-collect/components/service-payment';
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { paymentDetailById } from 'services/payment.service';
import { handleError } from 'utils/helpers';
import paymentSuccessful from 'assets/images/icons/campaign-data-collection/payment-successful.png';
// import paymentFailed from 'assets/images/icons/campaign-data-collection/payment-failed.png';

const PaymentResults = () => {
    const steps = ['Chọn đối tượng', 'Hóa đơn điện tử', 'Thanh toán'];
    const [searchParams] = useSearchParams();
    const transactionStatus = searchParams.get('vnp_TransactionStatus');

    const activeStep = 2;

    const paymentId = useParams().id;
    const [paymentDetail, setPaymentDetail] = React.useState<{
        id: number;
        status: string;
        client_email: string;
        order_id: string;
        paymentUrl: string;
    }>({
        id: 0,
        status: '',
        client_email: '',
        order_id: '',
        paymentUrl: '',
    });

    console.log(paymentDetail);

    React.useEffect(() => {
        const fetchPaymentDetails = async (id: string) => {
            try {
                const response = await paymentDetailById(Number(id));
                if (response.success) {
                    const attributes = response.data.payment.attributes;
                    setPaymentDetail({
                        id: attributes.id,
                        status: attributes.status,
                        client_email: attributes.client_email,
                        order_id: attributes.order_id,
                        paymentUrl: attributes.url_payment || '',
                    });
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                handleError(error);
            }
        };
        if (paymentId) {
            fetchPaymentDetails(paymentId);
        }
    }, [paymentId]);
    return (
        <Box mt={5}>
            <Stack direction="row" spacing={2}>
                <Typography
                    variant="h3"
                    component="h3"
                    sx={{
                        fontWeight: '700',
                        fontSize: 28,
                        lineHeight: '33.89px',
                        color: (theme) => theme.palette.primary.main,
                    }}
                >
                    Thêm thanh toán
                </Typography>
            </Stack>

            <Box sx={{ width: '60%', mx: 'auto' }}>
                <Stepper
                    nonLinear
                    activeStep={activeStep}
                    alternativeLabel
                    connector={<CustomStepConnector />}
                >
                    {steps.map((item, index) => {
                        const isCompleted = index < activeStep;

                        return (
                            <Step key={index} completed={isCompleted}>
                                <StepButton
                                    disableRipple
                                    sx={{
                                        cursor: 'default',
                                        '& .MuiStepLabel-label': {
                                            color: 'var(--color-primary) !important',
                                        },
                                    }}
                                >
                                    <StepLabel
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: '1.5rem',
                                                fontWeight: 500,
                                            },
                                        }}
                                        StepIconComponent={(props) => (
                                            <CustomStepIcon
                                                {...props}
                                                step={index}
                                            />
                                        )}
                                    >
                                        {item}
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        );
                    })}
                </Stepper>
            </Box>

            <Box>
                <Box sx={{ textAlign: 'center' }}>
                    {(paymentDetail.status === 'paid' ||
                        transactionStatus === '00') && (
                        <>
                            <img
                                src={paymentSuccessful}
                                alt="payment"
                                style={{
                                    width: '20%',
                                    marginBottom: '24px',
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: 600,
                                    color: 'primary.main',
                                    marginBottom: '24px',
                                }}
                            >
                                Thanh toán thành công
                            </Typography>
                            {!paymentDetail.client_email && (
                                <Typography
                                    sx={{
                                        marginBottom: '24px',
                                    }}
                                >
                                    Mã đơn hàng:{' '}
                                    <Box
                                        component={'span'}
                                        sx={{
                                            fontWeight: 700,
                                            color: 'primary.main',
                                        }}
                                    >
                                        {paymentDetail.order_id}
                                    </Box>
                                </Typography>
                            )}

                            {paymentDetail.client_email && (
                                <Typography
                                    sx={{
                                        marginBottom: '24px',
                                    }}
                                >
                                    Chi tiết đơn hàng “
                                    <Box
                                        component={'span'}
                                        sx={{
                                            fontWeight: 700,
                                            color: 'primary.main',
                                        }}
                                    >
                                        {paymentDetail.order_id}
                                    </Box>
                                    ” đã được gửi vào email{' '}
                                    <Box
                                        component={'span'}
                                        sx={{
                                            fontWeight: 700,
                                            color: 'primary.main',
                                        }}
                                    >
                                        {paymentDetail.client_email}
                                    </Box>{' '}
                                    của bạn. Vui lòng truy cập vào email để xem
                                    chi tiết.
                                </Typography>
                            )}
                        </>
                    )}
                    {paymentDetail.status === 'paid' ||
                    transactionStatus === '00' ? (
                        <></>
                    ) : (
                        <>
                            <Typography
                                variant="h3"
                                sx={{
                                    fontSize: '45px',
                                    fontWeight: 600,
                                    lineHeight: '54.46px',
                                    color: 'primary.main',
                                    mt: 5,
                                    mb: 5,
                                }}
                            >
                                Đơn hàng đang chờ thanh toán
                            </Typography>
                            <Box
                                mx={'auto'}
                                sx={{ display: 'flex', justifyContent: 'end' }}
                            >
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        width: '20%',
                                        minHeight: '48px',
                                        borderRadius: '60px',
                                        fontSize: '18px',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                    }}
                                    onClick={() => {
                                        window.open(
                                            paymentDetail.paymentUrl,
                                            '_blank'
                                        );
                                    }}
                                >
                                    Thanh toán
                                </Button>
                            </Box>
                        </>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default PaymentResults;
